module.exports = __webpack_public_path__ + "static/img/pay.e4fdc94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay.png
// module id = V8EB
// module chunks = 1